require("./ynet_ynetnews_vesty_site_verticalVideoOverlayPlayer.less");
import { VerticalVideoItem } from "./verticalVideoItem";
import { VerticalVideoGallery } from "./verticalVideoGallery";
import { SiteItemData } from "../../interfaces";
import { useEffect, useState } from "react";
import { categoryObj } from "../ynet1280/newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";

interface VerticalVideoOverlayPlayerProps {
    domain: string;
    isLTR: boolean;
    category: categoryObj
    isMobile: boolean;
    videoItems: SiteItemData | SiteItemData[];
    languageCode: string;
    isOverlayOpen: boolean;
    showPrerollAds: boolean;
    isTitleVisible: boolean;
    isSubTitleVisible: boolean;
    index?: number; //used in gallery view
    selectedVideoIndex?: number; //used in gallery view
    isSingleVideoDisplay?: boolean;
    onVideoOverlayClose: () => void;
}

export const VerticalVideoOverlayPlayer = (props: VerticalVideoOverlayPlayerProps) => {
    const { isOverlayOpen, index, isSingleVideoDisplay, onVideoOverlayClose, domain, videoItems, languageCode, showPrerollAds, isTitleVisible, selectedVideoIndex, isSubTitleVisible, isLTR, isMobile } = props;
    const [currentPlayingVideo, setCurrentPlayingVideo] = useState<number>(selectedVideoIndex);

    useEffect(() => {
        setCurrentPlayingVideo(selectedVideoIndex);
    }, [selectedVideoIndex])

    useEffect(() => {
        if (isOverlayOpen && !isMobile) {
            positionCloseButtonUnderHeader();
        }
    }, [isOverlayOpen])

    useEffect(() => {
        document.addEventListener('keydown', handleEscKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        }
    })

    const handleEscKeyPress = (e) => {
        if (e.keyCode === 27) {
            onVideoOverlayClose();
        }
    }

    const positionCloseButtonUnderHeader = () => {
        const closeButton = document.querySelector(".vertical-video-overlay-player .close-btn") as HTMLElement;
        const mainNavElement = document.querySelector(".BottomHeaderArea.sticky .mainNav") as HTMLElement;

        if (closeButton && mainNavElement) {
            const headerRect = mainNavElement.getBoundingClientRect();
            closeButton.style.right = `${headerRect.left + 30}px`;
        }
    };

    const pushGA4Event = (action: string, isFeedDisplay: boolean) => {
        if (typeof window == "undefined" || !window.dataLayer) return;
        const { category } = props;
        const actionPrefix = category && category.name ? (category.name === "דף הבית") ? "homepage" : category.name : "homepage";
        const gaAction = isFeedDisplay ? `video_${action}` : `${actionPrefix}_${action}`;

        window.dataLayer.push({
            event: "content_click",
            vertical_video_action: gaAction,
        });
    };

    if (!isOverlayOpen) return null;

    return (
        <div className={`vertical-video-overlay-player ${isSingleVideoDisplay ? "single-video-display" : "gallery-view"}`}>
            <div className="close-btn" onClick={onVideoOverlayClose}></div>

            {isSingleVideoDisplay ?
                <VerticalVideoItem
                    index={index}
                    domain={domain}
                    isMobile={isMobile}
                    languageCode={languageCode}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    videoItem={videoItems as SiteItemData}
                    currentPlayingVideo={currentPlayingVideo}
                    key={(videoItems as SiteItemData).itemId}
                    onVideoOverlayClose={onVideoOverlayClose}
                />
                :
                <VerticalVideoGallery
                    isLTR={isLTR}
                    domain={domain}
                    isMobile={isMobile}
                    languageCode={languageCode}
                    pushGA4Event={pushGA4Event}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    selectedVideoIndex={selectedVideoIndex}
                    videoItems={videoItems as SiteItemData[]}
                    onVideoOverlayClose={onVideoOverlayClose}
                    currentPlayingVideo={currentPlayingVideo}
                    setCurrentPlayingVideo={setCurrentPlayingVideo}
                />
            }
        </div>
    )
}
